// Paleta del tema Tactical. Alto contraste sobre fondo casi-negro.
// Prioriza legibilidad nocturna; rojos atenuados para evitar halation.

export default {
  meta: {
    id: 'tactical',
    nombre: 'Tactical',
    descripcion: 'Alto contraste sobre fondo casi-negro; legibilidad nocturna; rojos atenuados',
    modo: 'oscuro',
  },

  paleta: {
    'patrulla-normal':         '#378ADD',   // invertido: claro destaca sobre fondo oscuro
    'patrulla-atenuado':       '#0C447C',

    'camara-normal':           '#5DCAA5',
    'camara-atenuado':         '#0F6E56',
    // Ámbito de la cámara (placa/borde bajo el marker + leyenda del filtro).
    // Análogo frío + triádico cálido desaturados sobre camara-normal (#5DCAA5).
    'camara-estatal':          '#533073',
    'camara-municipal':        '#B25C40',
    'camara-otro':             '#68727E',

    'lpr-normal':              '#7F77DD',
    'lpr-atenuado':            '#3C3489',

    'bus-normal':              '#97C459',
    'bus-atenuado':            '#3B6D11',

    'sensor-standby':          '#FAC775',
    'sensor-alerta':           '#F09595',   // rojo claro, evita halation

    'incidente-activo':        '#F09595',
    'incidente-baja':          '#F7C1C1',

    // Familia cromática del manual oficial federal — versión tactical
    // (tonos claros con buen contraste para overlays HUD/tactical).
    'cat-seguridad':           '#7AAAE8',   // azul claro
    'cat-medico':              '#7AC489',   // verde claro
    'cat-proteccion-civil':    '#EBC745',   // amarillo dorado claro (separado de asistencia)
    'cat-servicios-publicos':  '#A48EE0',   // morado claro
    'cat-asistencia':          '#E9844A',   // naranja-rojizo claro (separado de PC)
    'cat-otros-servicios':     '#8A96A4',   // gris claro
    'cat-mal-uso':             '#E07162',   // rojo-coral claro

    // Devices: invertidos para fondo oscuro (claros = saltan visualmente)
    'device-policia-municipal-normal':    '#378ADD',
    'device-policia-municipal-atenuado':  '#0C447C',
    'device-policia-estatal-normal':      '#5BA0E0',
    'device-policia-estatal-atenuado':    '#1F5A8E',
    'device-policia-ministerial-normal':  '#A87DD0',
    'device-policia-ministerial-atenuado':'#6A4A8C',
    'device-gn-normal':                   '#E6BA60',
    'device-gn-atenuado':                 '#8A6E2A',
    'device-transito-normal':             '#EEA868',
    'device-transito-atenuado':           '#9A6A35',
    'device-ambulancia-normal':           '#E490B0',
    'device-ambulancia-atenuado':         '#933E66',
    'device-bomberos-normal':             '#F09595',
    'device-bomberos-atenuado':           '#A3493D',
    'device-proteccion-civil-normal':     '#E6BA60',
    'device-proteccion-civil-atenuado':   '#8A6E2A',
    'device-transporte-publico-normal':   '#97C459',
    'device-transporte-publico-atenuado': '#3B6D11',
    'device-funcionario-normal':          '#5FD0D2',
    'device-funcionario-atenuado':        '#1F7274',
    'device-dron-normal':                 '#C29DE0',
    'device-dron-atenuado':               '#5C2D9A',
    'device-otros-normal':                '#8A96A4',
    'device-otros-atenuado':              '#4A5562',

    'sos-esperando':           '#ED93B1',
    'sos-en-progreso':         '#ED93B1',
    'sos-finalizado':          '#F4C0D1',

    'neutro-apagado':          '#888780',
    'neutro-texto-oscuro':     '#F1EFE8',
    'neutro-texto-claro':      '#2C2C2A',
  },

  overrides: {
    'sensor.reported': {
      fondo: 'sensor-standby',
      borde: 'neutro-texto-claro',
      razon: 'Borde rojo en fondo oscuro genera halation. Usar borde claro.',
    },
    'sos.ENDED': {
      fondo: 'sos-finalizado',
      opacity: 0.50,
      razon: 'En modo oscuro los colores atenuados necesitan más reducción para distinguirse de activos.',
    },
  },
}
